<template>
  <span class="wordmark" :style="{ fontSize: size + 'px', color }">
    ecosa<span class="rule" :style="{ background: color }" />
  </span>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{ size?: number; color?: string }>(),
  { size: 22, color: "currentColor" }
);
</script>

<style scoped>
.wordmark {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  letter-spacing: -0.02em;
  position: relative;
  line-height: 1;
  padding-bottom: 4px;
  display: inline-block;
}
.rule {
  position: absolute;
  left: 0;
  right: 4px;
  bottom: 0;
  height: 2px;
  border-radius: 2px;
}
</style>
